var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-right",
    "data-name": "Icon feather-arrow-right",
    transform: "translate(22 -6) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67491",
    "data-name": "Path 67491",
    d: "M21,18.5H7a1,1,0,0,1,0-2H21a1,1,0,0,1,0,2Z",
    transform: "translate(0 -3.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67492",
    "data-name": "Path 67492",
    d: "M17.5,22a1,1,0,0,1-.707-1.707L23.086,14,16.793,7.707a1,1,0,1,1,1.414-1.414l7,7a1,1,0,0,1,0,1.414l-7,7A1,1,0,0,1,17.5,22Z",
    transform: "translate(-3.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2362ffe28b3f9940b869a8e9c34b2ec0.svg";
export { ForwardRef as ReactComponent };